import { DateStr, Station, toDateDiffRange, today, yesterday } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '../../../../../../core/hooks';
import { ListingView } from '../../../../../../core/reports/components/ListingView';
import { LiveMentionsForm } from './LiveMentionsForm';
import { LiveMentionsList } from './LiveMentionsList';
import { LiveMentionsMatchesListing } from './types';

type Props = {
  station: Station;
};

export function LiveMentionsMatchesView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<LiveMentionsMatchesListing>
      defaultValues={{
        ...toDateDiffRange(yesterday() as DateStr, today() as DateStr, tz),
        name: [],
      }}
      queryParamsTransform={{
        name: {
          parse: (input) => input.split(',').map((name) => ({ name })),
          serialize: (input) => input.map((v) => v.name).join(','),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchLiveMentionsMatches({
          stationId: p.station.id,
          filter: {
            from: values.from,
            to: values.to,
            name: (values.name || []).map(({ name }) => name).join(','),
          },
          pageSize: values.pageSize,
          page: values.pageIndex,
          sort: values.sort,
        });
      }}
      Form={LiveMentionsForm}
      Result={LiveMentionsList}
    />
  );
}
